module.exports = __webpack_public_path__ + "static/media/lillian.11713268.jpg";